import { extendTheme } from "@chakra-ui/react";

const breakpoints = {
  xs: "35rem", // 576px
  sm: "48rem", // 768px
  md: "62rem", // 992px
  lg: "75rem", // 1200px
  lp: "81.25rem", // 1300px
  xl: "87.5rem" // 1400px
};

export const textStyleLingLong = extendTheme({
  breakpoints,
  components: {
    Button: {
      variants: {
        "primary-button": {
          bg: "ll-green.main",
          borderRadius: "50px",
          color: "ll-white.main",
          height: "40px",
          textTransform: "uppercase",
          cursor: "pointer"
        },
        "secondary-button": {
          bg: "trasnparent",
          borderRadius: "50px",
          color: "ll-blue.main",
          border: "1px solid",
          borderColor: "ll-blue.main",
          height: "40px",
          textTransform: "uppercase",
          cursor: "pointer"
        }
      }
    }
  },
  colors: {
    "ll-white": {
      main: "#FFFFFF",
      "50": "#FFF5E5"
    },

    "ll-black": {
      "900": "#060808"
    },

    "ll-gray": {
      "100": "#ECECEC",
      "200": "#ABB4BD",
      "300": "#3B3B3B",
      "400": "#1C1C1C",
      "500": "#848484",
      "600": "#F7F5F6",
      "700": "#A9A9A9"
    },

    "ll-blue": {
      "300": "#1068D9",
      main: "#0C4EA2",
      "400": "#083166"
    },

    "ll-green": {
      "100": "#00D969",
      // main: "#128A15"
      main: "#00A550"
    },

    "ll-red": {
      main: "#E30000",
      "200": "#EB5757"
    }
  },

  fonts: {
    heading: "Work Sans, Noto Sans, Arial, sans-serif",
    body: "Work Sans, Noto Sans, Arial, sans-serif"
  },

  fontSizes: {
    titleExtraLarge: "4rem", //64px
    titleProduct: "2rem", //32px
    h1: "1.75rem", //28px
    h2: "1.5rem", //24px
    h3: "1.25rem", //20px
    h4: "1.125rem", //18px
    text1: "1rem", //16px
    text2: "0.875rem", //14px
    text3: "0.75rem", //12px
    text4: "0.625rem" //10px
  },

  textStyles: {
    Header: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: "400",
      color: "ll-gray.500",
      fontSize: "text1"
    }
  },

  styles: {
    global: {
      body: {
        bg: "#ECECEC",
        color: "gray.700"
      }
    }
  }
});
